import { ProcessingStatusModel } from './processing-status-model';
import { ServiceResponse } from '@sdbn/common';
import { MessagingProvider } from './messagingprovider';
import { DataProtectionRule } from './data-protection-rule';
import { TransportOption } from './transport-option';
import { StationGroup } from './station-group';
import { Dashboard } from '@sdbn/common';
import { ModuleGroup } from '@sdbn/common';
import { Station } from './station';
import { StationSet } from './station-set';
import { CustomFilter } from '@sdbn/tmc-common';
import { TransportColoringTheme } from '../../api/transportvisualization/transportvisualization.model';


export enum TaskType {
  CHECK = 'CHECK', MESSAGE = 'MESSAGE', DOCUMENT = 'DOCUMENT', PICTURE = 'PICTURE', ATTRIBUTE_CHANGE = 'ATTRIBUTE_CHANGE', PICTURE_SERIES = 'PICTURE_SERIES'
}

export enum TaskRelevance {

  OPTIONAL = 'OPTIONAL',

  /* entrance and leave */
  ON_ENTRANCE = 'ON_ENTRANCE',
  ON_LEAVE = 'ON_LEAVE',

  /* station behaviour */
  BEFORE_RETRIEVE = 'BEFORE_RETRIEVE',
  BEFORE_PROCESSING_STATUS = 'BEFORE_PROCESSING_STATUS',
  AFTER_RETRIEVE = 'AFTER_RETRIEVE',
  BEFORE_FINISH = 'BEFORE_FINISH',

  /* automatisized */
  AUTOMATICALLY_ON_RETRIEVE = 'AUTOMATICALLY_ON_RETRIEVE',
  AUTOMATICALLY_ON_PROCESSING_STATUS = 'AUTOMATICALLY_ON_PROCESSING_STATUS',
  AUTOMATICALLY_ON_COMPLETE_PROCESSING_STATION = 'AUTOMATICALLY_ON_COMPLETE_PROCESSING_STATION',
  AUTOMATICALLY_ON_FINISH_TRANSPORT = 'AUTOMATICALLY_ON_FINISH_TRANSPORT',
  AUTOMATICALLY_ON_ATTACH_TRUCK = 'AUTOMATICALLY_ON_ATTACH_TRUCK',
  AUTOMATICALLY_WHEN_AVAILABLE = 'AUTOMATICALLY_WHEN_AVAILABLE'

}


export class Task {
  id: number;
  externalKey: string;
  nameDictionaryKey: string;
  selected: boolean;
  relevance: TaskRelevance;
  type: TaskType;
  documentTemplateId: number;

  constructor(task: Task) {
    this.id = task.id;
    this.externalKey = task.externalKey;
    this.nameDictionaryKey = task.nameDictionaryKey;
    this.selected = task.selected;
    this.relevance = task.relevance;
    this.type = task.type;
    this.documentTemplateId = task.documentTemplateId;
  }
}

export enum TransportOptionConstraintType {
  MIN_SELECTED_COUNT = 'MIN_SELECTED_COUNT'
}

export class TransportOptionConstraint {
  id: number;
  name: string;
  count: number;
  type = TransportOptionConstraintType.MIN_SELECTED_COUNT;
  transportOptionIds = new Array<number>();

  constructor(constraint: TransportOptionConstraint) {
    this.id = constraint.id;
    this.name = constraint.name;
    this.count = constraint.count;
    this.type = constraint.type;
    if (constraint.transportOptionIds != null) {
      this.transportOptionIds.push(...constraint.transportOptionIds);
    }
  }
}

export class TransportOptionCondition {
  id: string | undefined;

  constructor(condition?: Partial<TransportOptionCondition>) {
    if (condition) {
      this.id = condition.id;
    }
  }
}

export class YardConfiguration extends ServiceResponse {

  yardKey: string;
  messagingProvider = new Array<MessagingProvider>();
  customFilters: CustomFilter[] = [];
  processingStatusModels: ProcessingStatusModel[] = [];
  dataProtectionRules: DataProtectionRule[] = [];
  transportOptions = new Array<TransportOption>();
  transportOptionConstraints = new Array<TransportOptionConstraint>();
  transportOptionConditions = new Array<TransportOptionCondition>();
  stationGroups = new Array<StationGroup>();
  stations = new Array<Station>();
  tasks = new Array<Task>();
  dashboards = new Array<Dashboard>();
  moduleGroups = new Array<ModuleGroup>();
  coloringThemes = new Array<TransportColoringTheme>();

  constructor(yardConfiguration: YardConfiguration) {
    super(yardConfiguration);
    this.yardKey = yardConfiguration.yardKey;
    for (const provider of yardConfiguration.messagingProvider) {
      this.messagingProvider.push(provider);
    }
    for (const filter of yardConfiguration.customFilters) {
      this.customFilters.push(new CustomFilter(filter));
    }
    for (const model of yardConfiguration.processingStatusModels) {
      this.processingStatusModels.push(new ProcessingStatusModel(model));
    }
    for (const rule of yardConfiguration.dataProtectionRules) {
      this.dataProtectionRules.push(new DataProtectionRule(rule));
    }
    for (const option of yardConfiguration.transportOptions) {
      this.transportOptions.push(new TransportOption(option));
    }
    for (const constraint of yardConfiguration.transportOptionConstraints) {
      this.transportOptionConstraints.push(new TransportOptionConstraint(constraint));
    }
    for (const condition of yardConfiguration.transportOptionConditions) {
      this.transportOptionConditions.push(new TransportOptionCondition(condition));
    }
    for (const stationGroup of yardConfiguration.stationGroups) {
      this.stationGroups.push(new StationGroup(stationGroup));
    }
    for (const station of yardConfiguration.stations) {
      this.stations.push(new Station(station));
    }
    for (const task of yardConfiguration.tasks) {
      this.tasks.push(new Task(task));
    }
    for (const dashboard of yardConfiguration.dashboards) {
      this.dashboards.push(new Dashboard(dashboard));
    }
    for (const moduleGroup of yardConfiguration.moduleGroups) {
      this.moduleGroups.push(new ModuleGroup(moduleGroup));
    }
    for (const coloringTheme of yardConfiguration.coloringThemes) {
      this.coloringThemes.push(new TransportColoringTheme(coloringTheme));
    }
    this.mapStationsToStationSets();
  }

  // Stations Objekte zu Referenz Mappen
  private mapStationsToStationSets() {
    const stationsById = new Map<number, Station>();
    this.stations.forEach(
      s => stationsById.set(s.id, s)
    );

    for (const sg of this.stationGroups) {
      for (const set of sg.stationSets) {
        for (const stationId of set.stationIds) {
          const station = stationsById.get(stationId);
          if (station != null) {
            set.stations.push(station);
          }
        }
      }
    }
  }

  public getStationGroupById(id: number): StationGroup {
    return this.stationGroups.find(sg => sg.id === id);
  }

  public getStationSetById(id: number): StationSet {
    for (let group of this.stationGroups) {
      for (let stationSet of group.stationSets) {
        if (stationSet.id === id) {
          return stationSet;
        }
      }
    }
    console.log('no station set available for id', id);
    return null;
  }

  public getStationById(id: number): Station {
    return this.stations.find(s => s.id === id);
  }
}
